module.exports = __webpack_public_path__ + "Group 15715.25dcaae344b3c5bc528d.png";